import { CourseCatalogLandingPage } from './course-catalog-landing-page.model';

export class CourseCatalogLandingPageCommand {
    title: string;
    description: string;
    short_description: string;
    language: string;
    status: string;
    image: {
        id: number;
    };

    constructor(query: CourseCatalogLandingPage) {
        this.title = query.title;
        this.description = query.description;
        this.short_description = query.shortDescription;
        this.language = query.language;
        this.status = query.status;

        this.image = query.image ? { id: Number(query.image.id) } : null;
    }
}
